import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface DeliveryData {
    delivery_idx: number;
    delivery_name: string;
}

interface GetDeliveryResponse {
    data: DeliveryData[];
}

export const useGetCommonDelivery = (searchtxt?: string): UseQueryResult<GetDeliveryResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetDeliveryResponse, Error>({
        queryKey: ["getCommonDelivery", searchtxt],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.common_get_delivery}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    search: "delivery_name",
                    searchtxt,
                },
            });
            return response.data;
        },
    });
};
